import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EquipmentGroupPreview} from './equipment-group-preview';
import {EquipmentCardInterfaces} from '@namespaces/equipment.namespace';

@Component({
    selector: 'app-equipment-group-preview',
    templateUrl: 'equipment-group-preview.component.html',
    styleUrls: ['equipment-group-preview.component.scss']
})

export class EquipmentGroupPreviewComponent implements OnInit {
    @Input() group: EquipmentGroupPreview;

    @Output() editClicked = new EventEmitter<EquipmentCardInterfaces.Card.ItemView>();
    @Output() addClicked = new EventEmitter();

    constructor() {
    }

    ngOnInit() {
    }

    onAddClick() {
        this.addClicked.emit();
    }

    onEditClick(value: EquipmentCardInterfaces.Card.ItemView) {
        this.editClicked.emit(value);
    }
}
